import styled from 'styled-components'

export const StyledVolumesVideoTutorial = styled.div``
